import React from "react";
import axios from "axios";

//Matrial-ui core
import { CircularProgress, Dialog, DialogContent, DialogTitle, Slide } from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";

//Core items
import Button from "../../../components/CustomButtons/Button";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import ApiLog from "./Detail/ApiLog";

//Tab items
import ArtikelTable from "./Detail/ArtikelTable";
import CustomFields from "./Detail/CustomFields";
import Notificaties from "./Detail/Notificaties";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";

//Globale functies
import { verifyEmail } from "../../../utils";
import VoucherLog from "./Detail/VoucherLog";
import PaymentLog from "./Detail/PaymentLog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Detail extends React.Component {
  emailInput = React.createRef();
  mailButton = React.createRef();

  state = {
    saving: false,
    bestelling: {},
    loading: true,
    canSendEmail: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && prevProps.open !== this.props.open) {
      this.loadBestelling();
    }

    if (this.props.open === false && prevProps.open !== this.props.open) {
      this.setState({ loading: true });
    }
  }

  loadBestelling = () => {
    axios.get("core/bestellingen/" + this.props.bestellingId).then((response) => {
      this.setState({ bestelling: response.data.data, loading: false });
    });
  };

  hideOrder = () => {
    axios.get("core/bestellingen/" + this.props.bestellingId).then((response) => {
      this.setState({ bestelling: response.data.data, loading: false });
    });
  };

  handleMailNotification = () => {
    let email = this.emailInput.current.value;

    axios
      .get(
        "/payment/paynl/sentinvoice/" + this.state.bestelling.id + "/" + this.state.bestelling.hash + "?mail=" + email,
        {
          baseURL: "",
        }
      )
      .then(() => {
        this.mailButton.current.style.backgroundColor = "#44b344";
        this.setState({ canSendEmail: false });
      })
      .catch(() => {
        this.mailButton.current.style.backgroundColor = "#b34444";
      });
  };

  verifyEmail = () => {
    let email = this.emailInput.current.value;

    if (verifyEmail(email)) {
      this.setState({ canSendEmail: true });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth={true}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
        scroll={"paper"}
      >
        {!this.state.loading ? (
          <div>
            <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
              <Button
                aria-label={"Close"}
                className={classes.modalCloseButton}
                color={"transparent"}
                justIcon
                key={"close"}
                onClick={this.props.toggle}
              >
                <Close className={classes.modalClose} />
              </Button>
              <h4 className={classes.modalTitle}>
                <TranslationWrapper tDefault={"Items in bestelling"} tKey={"bestellingen.modal.detail.title"} /> #
                {this.state.bestelling.id}
              </h4>
            </DialogTitle>
            <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
              <GridContainer>
                <GridItem md={4}>
                  <TranslationWrapper tDefault={"Tafel"} tKey={"bestellingen.modal.detail.text.tafel"} />
                </GridItem>
                <GridItem md={8}>{this.state.bestelling.table ? this.state.bestelling.table.naam : ""}</GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={4}>
                  <TranslationWrapper tDefault={"Sessie"} tKey={"bestellingen.modal.detail.text.sessie"} />
                </GridItem>
                <GridItem md={8}>{this.state.bestelling.sessionid}</GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={4}>
                  <TranslationWrapper
                    tDefault={"Retry count / payment checks"}
                    tKey={"bestellingen.modal.detail.text.apiRetrCountPaymentChecks"}
                  />
                </GridItem>
                <GridItem md={8}>
                  {this.state.bestelling.retryCount} / {this.state.bestelling.paymentChecks}
                </GridItem>
              </GridContainer>
              <CustomFields customFields={this.state.bestelling.customFields} />
              <GridContainer>
                <GridItem md={4}>
                  <TranslationWrapper
                    tDefault={"Artikel(en)"}
                    tKey={"bestellingen" + "." + "modal.detail.text.artikelen"}
                  />
                </GridItem>
                <GridItem md={8}>
                  <ArtikelTable
                    items={this.state.bestelling.items}
                    valuta={this.state.bestelling.vestiging !== null ? this.state.bestelling.vestiging.valuta : "EUR"}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={4}>
                  <TranslationWrapper tDefault={"Bon Mailen"} tKey={"bestellingen.modal.detail.text.bonMailen"} />
                </GridItem>
                <GridItem md={4}>
                  <input name={"bonmailen"} onChange={this.verifyEmail} ref={this.emailInput} type={"text"} />
                </GridItem>
                <GridItem md={4}>
                  <Button
                    color={"info"}
                    disabled={!this.state.canSendEmail}
                    onClick={this.handleMailNotification}
                    ref={this.mailButton}
                    style={{ width: "100%" }}
                  >
                    <TranslationWrapper tDefault={"verzend mail"} tKey={"bestellingen.modal.detail.text.sendmail"} />
                  </Button>
                </GridItem>
              </GridContainer>
              {/* <GridContainer>
                <GridItem md={4}></GridItem>
                <GridItem md={4}></GridItem>
                <GridItem md={4}>
                  <Button color={"danger"} onClick={this.hideOrder} style={{ width: "100%" }}>
                    {
                      <TranslationWrapper
                        tKey={"bestellingen.modal.detail.text.hideOrder"}
                        tDefault={"Haal bestelling uit overzicht"}
                      />
                    }
                  </Button>
                </GridItem>
              </GridContainer> */}
              <Notificaties bestelling={this.state.bestelling} />
              <ApiLog {...this.props} />
              <VoucherLog {...this.props} />
              <PaymentLog {...this.props} />
            </DialogContent>
          </div>
        ) : (
          <div style={{ margin: "25px auto" }}>
            <CircularProgress />
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(Detail, notificationsStyle);
